'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseDropdown = require('@bibliocommons/base-dropdown');

require('../styles/SortDropDown.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SortDropdown = function (_BcReactComponent) {
  _inherits(SortDropdown, _BcReactComponent);

  function SortDropdown(props) {
    _classCallCheck(this, SortDropdown);

    var _this = _possibleConstructorReturn(this, (SortDropdown.__proto__ || Object.getPrototypeOf(SortDropdown)).call(this, props));

    _this.labelledById = _lodash2.default.uniqueId('sortDropdown_');
    _this.bindAll('currentSort', 'getOptions', 'handleSelect');
    return _this;
  }

  _createClass(SortDropdown, [{
    key: 'currentSort',
    value: function currentSort() {
      var option = this.props.options.find(function (sort) {
        return sort.get('applied');
      });
      return option ? this.props.intl.formatMessage({ id: 'sort.' + option.get('id').toLowerCase() }) : this.props.intl.formatMessage({ id: 'sort.relevancy' });
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var _this2 = this;

      var options = this.props.options.map(function (option) {
        return {
          key: 'sort-dropdown-option-' + option.get('id'),
          label: _this2.props.intl.formatMessage({ id: 'sort.' + option.get('id').toLowerCase() }),
          value: option.get('id')
        };
      });

      return options;
    }
  }, {
    key: 'handleSelect',
    value: function handleSelect(id) {
      if (this.props.sort) {
        this.props.sort(id);
      } else {
        var _extends2;

        var _props = this.props,
            location = _props.location,
            router = _props.router,
            paginationField = _props.paginationField,
            queryField = _props.queryField;

        router.push(_extends({}, location, {
          query: _extends({}, location.query, (_extends2 = {}, _defineProperty(_extends2, queryField, id), _defineProperty(_extends2, paginationField, undefined), _extends2))
        }));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var right = this.props.right;

      return _react2.default.createElement(
        'span',
        { className: 'cp-sort-dropdown' },
        _react2.default.createElement(_baseDropdown.Dropdown, {
          selected: this.props.intl.formatMessage({ id: 'Search.sortBy' }, { currentSort: this.currentSort() }),
          options: this.getOptions(),
          handleSelect: this.handleSelect,
          describedById: this.describedById,
          labelledById: this.labelledById,
          descriptionLocaleKey: 'sortDropdownDescription',
          className: 'btn-link',
          right: right })
      );
    }
  }]);

  return SortDropdown;
}(_baseBcReactComponent2.default);

SortDropdown.propTypes = {
  options: _reactImmutableProptypes2.default.list,
  sort: _react.PropTypes.func,
  right: _react.PropTypes.bool,
  queryField: _react.PropTypes.string,
  paginationField: _react.PropTypes.string,
  intl: _reactIntl.intlShape
};

SortDropdown.defaultProps = {
  paginationField: 'page',
  queryField: 'sort'
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactRouter.withRouter)(SortDropdown));


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/sort-dropdown/lib/components/SortDropDown.component.js
// module id = 1542
// module chunks = 1